import { QueryStore } from '../../stores';
import { IExecutionOptions, IQueryOptions } from '../query';
import { GlobalDisclaimerLevel } from './GlobalDisclaimerLevel';
import { IGlobalDisclaimerStoreAddOptions } from './IGlobalDisclaimerStoreAddOptions';
import { TGlobalDisclaimerStoreAppsByKey } from './TGlobalDisclaimerStoreAppsByKey';

export class GlobalDisclaimerStoreValue {
	queryStore: QueryStore;
	disclaimerType: string;
	key: string;
	responseContext: any;
	appKey: string;
	superscript: number;
	order: number;
	appsByKey: TGlobalDisclaimerStoreAppsByKey;
	level: GlobalDisclaimerLevel;
	textQuery: Partial<IQueryOptions>;
	hasHtml: boolean;
	constructor(queryStore: QueryStore, superscript: number, key: string, responseContext: any, appKey: string, options: IGlobalDisclaimerStoreAddOptions) {
		const { disclaimerType, textQuery, hasHtml = true, order } = options;
		this.queryStore = queryStore;
		this.disclaimerType = disclaimerType;
		this.appKey = appKey;
		this.key = key;
		this.responseContext = responseContext;
		this.textQuery = textQuery;
		this.hasHtml = hasHtml;
		this.superscript = superscript;
		this.order = order || GlobalDisclaimerStoreValue.maxOrder;
		this.addApp(appKey, options);
	}
	static maxOrder = 999999;
	addApp(key: string, app: IGlobalDisclaimerStoreAddOptions) {
		if (!this.appsByKey) {
			this.appsByKey = {};
		}
		this.appsByKey[key] = {
			...app,
			appKey: key,
			level: app.level || GlobalDisclaimerLevel.page,
		};
		this.updateLevel();
	}
	updateLevel() {
		const apps = Object.values(this.appsByKey);
		this.level = apps.some(app => app.level === GlobalDisclaimerLevel.page) ? GlobalDisclaimerLevel.page : GlobalDisclaimerLevel.app;
	}
	matches(level: GlobalDisclaimerLevel, appKey?: string) {
		return this.level === level && (!appKey || !!this.appsByKey[appKey]);
	}
	get text(): string {
		return GlobalDisclaimerStoreValue.getText(this.queryStore, this.disclaimerType, this.textQuery, this.responseContext);
	}
	static getText = (queryStore: QueryStore, disclaimerType: string, initialTextQuery: Partial<IQueryOptions>, responseContext: any) => {
		if (queryStore && initialTextQuery) {
			const textQuery: IQueryOptions = {
				...initialTextQuery,
				queryOptionsType: initialTextQuery.queryOptionsType || 'disclaimers',
			};
			if (textQuery.queryOptionsType === 'disclaimers' && (!textQuery.key || !textQuery.keyQuery) && (!textQuery.options || !textQuery.options.disclaimers || (!textQuery.options.disclaimers.key && !textQuery.options.disclaimers.keyQuery))) {
				if (!textQuery.options) {
					textQuery.options = {};
				}
				if (!textQuery.options.disclaimers) {
					textQuery.options.disclaimers = {};
				}
				textQuery.options.disclaimers.key = disclaimerType;
			}
			const overrideExecutionOptions: Partial<IExecutionOptions> = {};
			if (responseContext) {
				overrideExecutionOptions.responseContext = responseContext;
			}
			return queryStore.query(textQuery, overrideExecutionOptions);
		}
		return '';
	}
}